(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function shut() {
      var panel = document.getElementById('aedb-mobile');
      var burger = document.querySelector('.aedb-burger');
      if (!panel || panel.hasAttribute('hidden')) return;
      panel.setAttribute('hidden', '');
      if (burger) {
        burger.setAttribute('aria-expanded', 'false');
        burger.classList.remove('is-open');
      }
    }

    document.addEventListener('click', function (e) {
      var burger = e.target.closest('.aedb-burger');
      var panel = document.getElementById('aedb-mobile');
      if (!panel) return;

      if (burger) {
        var opening = panel.hasAttribute('hidden');
        if (opening) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
        burger.setAttribute('aria-expanded', opening ? 'true' : 'false');
        burger.classList.toggle('is-open', opening);
        return;
      }

      /* tapping anywhere off the panel closes it — leaving it open over the
         page was the single most common way to get stuck on a phone */
      if (!panel.hasAttribute('hidden') && !e.target.closest('#aedb-mobile')) shut();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') shut();
    });

    /* rotating to landscape can put the desktop nav back — drop the panel */
    window.addEventListener('resize', function () {
      if (window.innerWidth > 900) shut();
    });

    var header = document.querySelector('[data-aedb-header]');
    if (!header) return;
    var stuck = false;
    var onScroll = function () {
      var now = window.scrollY > 8;
      if (now !== stuck) { stuck = now; header.classList.toggle('is-stuck', now); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();
})();
